import { render, staticRenderFns } from "./comp-background.vue?vue&type=template&id=abbc562a&scoped=true"
import script from "./comp-background.vue?vue&type=script&lang=js"
export * from "./comp-background.vue?vue&type=script&lang=js"
import style0 from "./comp-background.vue?vue&type=style&index=0&id=abbc562a&prod&lang=scss&scoped=true"
import style1 from "./comp-background.vue?vue&type=style&index=1&id=abbc562a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbc562a",
  null
  
)

export default component.exports